module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4iIdx"))).then(() => parcelRequire('1iHdE'));